import { EMPTY_SEARCH_MODE_ENTITY } from "domain/entity/ChargeDataEnquiry/SearchModeEntity";
import { ChargeDetailConstant } from "presentation/constant/ChargeDetailMaintenance/ChargeDetailConstant";
import { MessageConstant } from "presentation/constant/MessageConstant";
import { useChargeDetailVM } from "presentation/hook/ChargeDetailMaintenance/useChargeDetailVM";
import { useChargeHeaderMaintenanceVM } from "presentation/hook/ChargeHeaderMaintenance/useChargeHeaderMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useChargeDetailTracked } from "presentation/store/ChargeDetailMaintenance/ChargeDetailProvider";
import { useChargeHeaderMaintenanceTracked } from "presentation/store/ChargeHeaderMaintenance/ChargeHeaderMaintenanceProvider";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, SidebarTitle, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { CriteriaItemContainer } from "presentation/view/components/CriteriaItemContainer";

const AssignManualTsLegChargeIndPanel = () => {
    const CHARGEDETAIL_CONSTANT = ChargeDetailConstant.Charge;
    const chargeDetailVM = useChargeDetailVM();
    const chargeHeaderVM = useChargeHeaderMaintenanceVM();
    const [chargeDetailState] = useChargeDetailTracked();
    const [chargeHeaderState] = useChargeHeaderMaintenanceTracked();
    const { selectedChargeDetails, chargeBatchUpdate } = chargeDetailState;
    const messageBarVM = useMessageBarVM();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const closeButtonClicked = useCallback(() => {
        chargeDetailVM.onAssignManTSLegIndCloseClick();
    }, [chargeDetailVM]);

    const saveButtonClicked = useCallback(async () => {
        let newSearchCriteria = chargeDetailState.searchCriteria;
        newSearchCriteria = { ...newSearchCriteria, chargeHdrId: Number(chargeDetailState?.currentChargeHeader?.id ?? chargeHeaderState?.currentChargeHeader?.id) ?? 0 }

        setIsLoading(true);
        chargeDetailVM.onChargeDetailTSLegIndUpdateSave(selectedChargeDetails, chargeBatchUpdate.tsLegChargeInd).then(async (data) => {
            Promise.allSettled([
                chargeDetailVM.getChargeDetails(newSearchCriteria),
                chargeHeaderVM.onSearch({
                    ...chargeDetailState.searchCriteria,
                    id: chargeDetailState?.currentChargeHeader?.id ?? chargeHeaderState?.currentChargeHeader?.id
                }, EMPTY_SEARCH_MODE_ENTITY, true, true)
            ]).finally(() => {
                if (data && data["updateTSLegChargeIndFail"]) {
                    const err: string = data["updateTSLegChargeIndFail"]?.toString() ?? "";
                    messageBarVM.showError(err.replace("Error:", ""));
                } else {
                    messageBarVM.showSuccess(MessageConstant.charge.ASSIGN_MAN_TS_LEG_IND_SUCCESSFUL);
                }
                setIsLoading(false);
            });
        }).catch(() => {
            setIsLoading(false);
        }).finally(() => {
            setIsLoading(false);
            chargeDetailVM.onAssignManTSLegIndCloseClick();
        });
    }, [chargeDetailState.searchCriteria, chargeDetailState?.currentChargeHeader?.id, chargeHeaderState?.currentChargeHeader?.id, chargeDetailVM, selectedChargeDetails, chargeBatchUpdate.tsLegChargeInd, chargeHeaderVM, messageBarVM])

    const memoTsLegChargeInd = useMemo(() =>
        <div className={'im-flex-row'} style={{ marginBottom: '24px' }}>
            <div className='im-flex-row-item' style={{ width: "240px" }}>
                <NbisCommonField
                    errorMessages={{}}
                    isReadOnly={false}
                    isShowOptional={false}
                    readOnlyValue={chargeBatchUpdate.tsLegChargeInd ?? ""}
                    fieldValue={chargeBatchUpdate.tsLegChargeInd}
                    fieldLabel={"TS Leg Charge Ind."}
                    isSaveClicked={false}
                    fieldType={FieldType.DROPDOWN}
                    fieldKey={'tsLegChargeInd'}
                    options={chargeDetailState.dynamicOptions.transhipmentLegChargeIndDropdownOptions}
                    requiredFieldList={[]}
                    onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                        chargeDetailVM.onChargeBatchUpdateFieldChange(fieldKey, fieldValue && fieldValue, fFullValue)} />
            </div>

        </div>
        , [chargeBatchUpdate.tsLegChargeInd, chargeDetailState.dynamicOptions.transhipmentLegChargeIndDropdownOptions, chargeDetailVM])

    return (
        <div className='side-form-content-wrapper' style={{ height: 'calc(100vh - 8vh - 62px)' }}>
            {isLoading && <Loader size="Medium" Indicator="Spinner"></Loader>}
            <div className={'flex-row'}>
                <div className={'flex-row-item flex-row-item-full-width'}>
                    <Sidebarheader>
                        <SidebarTitle>{CHARGEDETAIL_CONSTANT.ASSIGN_TS_LEG_CHG_IND}</SidebarTitle>
                    </Sidebarheader>
                </div>
            </div>
            <div className={'add-edit-form'}>
                <div className="flex-row-auto">
                    <div className={'flex-row-item'}>
                        <CriteriaItemContainer>
                            {memoTsLegChargeInd}
                        </CriteriaItemContainer>
                    </div>
                </div>
            </div>
            <SidebarActionBar>
                <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={closeButtonClicked} />
                <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={saveButtonClicked} />
            </SidebarActionBar>
        </div>
    );
}

export default memo(AssignManualTsLegChargeIndPanel);